import { render } from "./AboutfdHome.vue?vue&type=template&id=2d5687d9&scoped=true&ts=true"
import script from "./AboutfdHome.vue?vue&type=script&lang=ts"
export * from "./AboutfdHome.vue?vue&type=script&lang=ts"

import "./AboutfdHome.vue?vue&type=style&index=0&id=2d5687d9&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5687d9"]])

export default __exports__